import _ from 'lodash';
import platformUtils from 'platformUtils';
import reporter from 'privates/reporter';
import {generateError} from 'privates/validations/errors';

const VECTOR_MEDIA_SRC_REGEX = /^wix:vector:\/\/v1\/([^\/]+)\/([^\/]+)?$/;

function isValidVectorImage(src) {
    const mediaSrcHandler = platformUtils.getMediaSrcHandler();
    if(mediaSrcHandler) { //TODO: remove after  mediaSrcHandler is fully merge in the viewer(dodo version)
        return VECTOR_MEDIA_SRC_REGEX.test(src); //TODO: remove after svg phase2 is merge in viewer
        // return mediaSrcHandler.isValidMediaSrc(src, mediaSrcHandler.types.VECTOR);
    }
    return VECTOR_MEDIA_SRC_REGEX.test(src);
}

function extractModelDataFromSrc(src) {
    const mediaSrcHandler = platformUtils.getMediaSrcHandler();
    if(mediaSrcHandler) { //TODO: remove after mediaSrcHandler is fully merge in the viewer(dodo version)
        const parseMediaItem = mediaSrcHandler.parseMediaSrc(src, mediaSrcHandler.types.VECTOR);
        if (parseMediaItem.error || parseMediaItem.type !== mediaSrcHandler.types.VECTOR) {  //TODO: remove || after viewer(e version) is fully merge
            return null;
        }

        if(!VECTOR_MEDIA_SRC_REGEX.test(src)) { //TODO: remove after svg phase2 is merge in viewer
            return null;
        }

        return {svgId: parseMediaItem.mediaId, title: parseMediaItem.title};
    }

    if (VECTOR_MEDIA_SRC_REGEX.test(src)) {
        const [, svgId, title] = src.match(VECTOR_MEDIA_SRC_REGEX) || [0, src];

        const decodedTitle = title ? decodeURIComponent(title) : '';
        return {svgId, title: decodedTitle};
    }

    return null;
}

function convertToModelFormatAndReportIfError(src, propertyName, functionName, index) {
    const svgData = extractModelDataFromSrc(src);
    if (!svgData) {
        const error = !_.isNil(index) ? generateError.error_bad_svg_format_with_index : generateError.error_bad_svg_format;
        reporter.reportSdkError(error({
            propertyName,
            functionName,
            index,
            wrongValue: src
        }));
        return null;
    }
    return svgData;
}

function buildFullUrlFromSvgId(svgId, title) {
    const mediaSrcHandler = platformUtils.getMediaSrcHandler();
    if(mediaSrcHandler) { //TODO: remove after  mediaSrcHandler is fully merge in the viewer(dodo version)
        const mediaItemUri = mediaSrcHandler.createMediaSrc({mediaId: svgId, type: mediaSrcHandler.types.VECTOR, title});
        if(mediaItemUri.error){
            return null;
        }
        return mediaItemUri.item;
    }

    if (!svgId) {
        return null;
    }

    const encodedTitle = title ? encodeURIComponent(title) : '';
    return `wix:vector://v1/${svgId}/${encodedTitle}`;
}

export default {
    isValidVectorImage,
    extractModelDataFromSrc,
    convertToModelFormatAndReportIfError,
    buildFullUrlFromSvgId
};



// WEBPACK FOOTER //
// ./js/modules/privates/utils/vectorImageUtils.es6